<style scoped>
    .navigation >>> .ivu-anchor-ink{height: 100%;right: 72px;top: 0;left: auto;}
    .navigation >>> .ivu-anchor-link{padding: 23px 0 0px 16px;}
    .navigation >>> .ivu-anchor-ink-ball{width: 17px;height: 17px;border-radius: 50%;background-color: #00a2e9;left: 50%;border: 3px solid #fff;}
    .catalog{display: inline-block;margin-top: 40px;}
    .catalog div{width: 4px;height: 18px;background-color: #00a2e9;display: inline-block;margin-right: 5px;vertical-align: text-bottom;}
    .catalog p{font-size: 16px;color: #00a2e9;display: inline-block;}
    .line{margin-bottom:25px}
    .navigation >>> .ivu-select{width: 440px;}
    .navigation >>> .ivu-input-suffix{top: 4px;}
    .navigation >>> .ivu-input-icon{top: 3px;}
    .navigation >>> .ivu-switch-checked {border-color: #45db5e;background-color: #45db5e;}
    .inputTips{display: inline-block;margin-right: 24px;font-size: 14px;color: #657180;text-align: right;vertical-align: top;margin-top: 8px;}
    .column{font-size: 14px;color: #464c5b;text-align: center;font-weight: bold;border-bottom: 1px solid #d7dde4;border-top: 1px solid #d7dde4;height: 59px;line-height: 59px;margin-top: 24px;}
    .columnContacts{text-align: center;font-size: 14px;color: #464c5b;line-height: 59px;}
    .projectRange{color: #464c5b;font-size: 14px;line-height: 35px;border-bottom: 1px solid #d7dde4;padding-bottom: 20px;margin-top: 25px;padding-left: 40px;}
    .name{display: inline-block;font-size: 14px;color: #464c5b;margin-left: 4px;}
    .mousedischarge{margin-bottom:15px;border-radius: 22px;height: 44px;border: 1px solid #d7dde4;display: inline-block;padding: 0 35px 0 5px;line-height: 44px;position: relative}
    .mouseremove{display: inline-block;line-height: 44px;padding: 0 35px 0 5px;}
    .close{position: absolute;right: 0;background-color: red;width: 16px;height: 16px;border-radius: 8px;}
    .operation{font-size: 14px;color: #464c5b;padding-bottom: 20px;margin-top: 10px;padding-left: 40px;}
    .project-Button{border-radius: 18px;border: 0;width: 110px;height: 36px;color: #fff;vertical-align: top}
</style>

<template>
  <div>
    <Row>
      <Col span="4">
        <Anchor class="navigation">
          <AnchorLink :href="$route.fullPath+'#catalog2'" title="当事人信息"/>
          <AnchorLink :href="$route.fullPath+'#catalog1'" title="模板选择"/>
          <!--<AnchorLink href="#catalog3" title="项目可见范围"/>-->
          <AnchorLink :href="$route.fullPath+'#catalog4'" title="案源律师设置"/>
          <AnchorLink :href="$route.fullPath+'#catalog5'" title="项目主办设置"/>
          <AnchorLink :href="$route.fullPath+'#catalog6'" title="项目成员设置"/>
          <AnchorLink :href="$route.fullPath+'#catalog7'" title="项目操作"/>
        </Anchor>
      </Col>
      <Col span="20" class="navigation" style="border-left: 1px solid #d7dde4;padding: 0px 40px">
        <div id="catalog2">
          <div class="catalog">
            <div></div>
            <p>当事人信息</p>
          </div>
          <div class="catalog" style="float: right;cursor:pointer" @click="saveLitigation()">
            <Icon type="md-add" color="#00a2e9" size="22" style="vertical-align: top;"/>
            <p>保存当事人信息</p>
          </div>
          <div style="margin-top: 20px;"></div>
          <Collapse simple :value="[1,2,3]">
            <Panel name="1">
              委托方身份信息
              <div slot="content">
                <template v-for="(item,index) in client">
                  <Row type="flex" align="middle">
                    <Col span="20">
                      <Row type="flex" align="middle" class="line">
                        <Col span="3" offset="1" class="text-key">委托人诉讼地位</Col>
                        <Col span="5" offset="1">
                          <Select v-model="item.litigation" style="width:100px">
                            <Option v-for="item in litigation" :value="item.value" :key="item.value">{{ item.label }}</Option>
                          </Select>
                        </Col>
                        <Col span="3" offset="1" class="text-key">
                          名称
                        </Col>
                        <Col span="5" offset="1">
                          <Input v-model="item.name"></Input>
                        </Col>
                      </Row>
                      <Row type="flex" align="middle" class="line">
                        <Col span="3" offset="1" class="text-key">身份类型</Col>
                        <Col span="5" offset="1">
                          <Select v-model="item.identity" style="width:100px">
                            <Option v-for="item in identity" :value="item.value" :key="item.value">{{ item.label }}</Option>
                          </Select>
                        </Col>
                        <Col span="3" offset="1" class="text-key">识别号码</Col>
                        <Col span="5" offset="1">
                          <Input v-model="item.IDCardCode" placeholder="身份证号/营业执照"></Input>
                        </Col>
                      </Row>
                    </Col>
                    <Col span="4">
                      <Button v-if="client.length>1" type="error" @click="client.splice(index,1)" icon="md-close">删除</Button>
                    </Col>
                  </Row>
                  <Divider :dashed="true"/>
                </template>
                <div style="text-align: center">
                  <Button type="success" style="width:150px" @click="client.push({name:'',IDCardCode:'',identity:'personal',litigation:'',})" icon="md-add">增 加</Button>
                </div>
              </div>
            </Panel>
            <Panel name="2">
              对方身份信息
              <div slot="content">
                <template v-for="(item,index) in opposed">
                  <Row>
                    <Col span="20">
                      <Row type="flex" align="middle" class="line">
                        <Col span="3" offset="1" class="text-key">诉讼地位</Col>
                        <Col span="5" offset="1">
                          <Select v-model="item.litigation" style="width:100px">
                            <Option v-for="item in litigation" :value="item.value" :key="item.value">{{ item.label }}</Option>
                          </Select>
                        </Col>
                        <Col span="3" offset="1" class="text-key">
                          名称
                        </Col>
                        <Col span="5" offset="1">
                          <Input v-model="item.name"></Input>
                        </Col>
                      </Row>
                      <Row type="flex" align="middle" class="line">
                        <Col span="3" offset="1" class="text-key">身份类型</Col>
                        <Col span="5" offset="1">
                          <Select v-model="item.identity" style="width:100px">
                            <Option v-for="item in identity" :value="item.value" :key="item.value">{{ item.label }}</Option>
                          </Select>
                        </Col>
                        <Col span="3" offset="1" class="text-key">识别号码</Col>
                        <Col span="5" offset="1">
                          <Input v-model="item.IDCardCode" placeholder="身份证号/营业执照"></Input>
                        </Col>
                      </Row>
                    </Col>
                    <Col span="4">
                      <Button v-if="opposed.length>1" type="error" @click="opposed.splice(index,1)" icon="md-close">删除</Button>
                    </Col>
                  </Row>
                  <Divider :dashed="true"/>
                </template>
                <div style="text-align: center">
                  <Button type="success" style="width:150px" @click="opposed.push({name:'',IDCardCode:'',identity:'personal',litigation:'',})" icon="md-add">增 加</Button>
                </div>
              </div>
            </Panel>
          </Collapse>
        </div>
        <!--案源律师设置-->
        <div id="catalog1">
          <div class="catalog">
            <div></div>
            <p>模板选择</p>
          </div>
          <!--<div class="catalog" style="float: right;cursor:pointer">-->
            <!--<Icon type="md-add" color="#00a2e9" size="22" style="vertical-align: top;"/>-->
            <!--<p>保存模板</p>-->
          <!--</div>-->
          <div style="border-top: 1px solid #d7dde4;margin-top: 20px;"></div>
          <!--选择模板-->
          <div style="margin:25px 0;">
            <p class="inputTips">选择模板</p>
            <Select @on-change="getModelTypeList" v-model="content.causeTypeSelected" filterable style="width: 214px;" placeholder="请选择案件案由">
              <Option v-for="(item,index) in causeTypeList" :value="item.id" :key="index.toString()" >{{ item.name }}</Option>
            </Select>
          </div>
          <!--案由-->
          <div style="margin: 25px 0;">
            <p class="inputTips">细分模板</p>
            <Select @on-change="getModelList" v-model="content.modelTypeSelected" style="width: 214px;" filterable placeholder="选择细分领域">
              <Option v-for="(item,index) in modelTypeList" :value="item.id" :key="index.toString()">{{ item.name }}</Option>
            </Select>
          </div>
          <!--模板名称-->
          <div style="margin: 25px 0;">
            <p class="inputTips">模板名称</p>
            <Select v-model="content.modelSelected" filterable style="width: 214px;" placeholder="选择案件细分领域">
              <Option v-for="(item,index) in modelList" :value="item.id" :key="index.toString()">{{ item.name }}</Option>
            </Select>
          </div>
        </div>
        <Divider dashed />
        <div id="catalog4">
          <div>
            <div class="catalog">
              <div></div>
              <p>案源律师设置</p>
            </div>
            <div class="catalog" style="float: right;">
              <userSelector
                  :userList="selectUserList"
                  @inputChange="getSelectUserList($event)"
                  @selected="content.source.push($event.id)"
              >
                <template slot="title">
                  <Icon type="md-add" color="#00a2e9" size="22" style="vertical-align: top;"/>
                  <p>添加律师</p>
                </template>
              </userSelector>
            </div>
          </div>
          <div style="border-top: 1px solid #d7dde4;margin-top: 20px;"></div>
          <!--案源律师-->
          <div style="margin: 25px 0">
            <div style="display: inline-block;margin-right: 15px;">
              <div v-if="userList.length>0" class="mousedischarge" style="margin-right: 5px;" v-for="(item,index) in content.source">
                <div class="close" @click="content.source.splice(index,1)">
                  <Icon type="ios-close" color="white" size="20" style="position: absolute;top: -2px;left: -2px;"/>
                </div>
                <Avatar style="vertical-align: top;margin-top: 4px;">{{userList.find((secItem)=>{return secItem.id==item}).name[0]}}</Avatar>
                <p class="name">{{userList.find((secItem)=>{return secItem.id==item}).name}}</p>
              </div>
              <div style="padding:5px"></div>
            </div>
          </div>
        </div>
        <!--项目主办设置-->
        <div id="catalog5">
          <div style="border-top:1px dashed #d7dde4;">
            <div class="catalog">
              <div></div>
              <p>项目主办设置</p>
            </div>
            <div class="catalog" style="float: right;">
              <userSelector
                  :userList="selectUserList"
                  @inputChange="getSelectUserList($event)"
                  @selected="content.manager.push($event.id);"
              >
                <template slot="title">
                  <Icon type="md-add" color="#00a2e9" size="22" style="vertical-align: top;"/>
                  <p>添加主办人</p>
                </template>
              </userSelector>
            </div>
          </div>
          <div style="border-top: 1px solid #d7dde4;margin-top: 20px;">
            <!--承办律师-->
            <div style="margin: 25px 0">
              <div style="display: inline-block;margin-right: 15px;">
                <div v-if="userList.length>0" class="mousedischarge" style="margin-right:5px;" v-for="(item,index) in content.manager">
                  <div class="close" @click="content.manager.splice(index,1)">
                    <Icon type="ios-close" color="white" size="20" style="position: absolute;top: -2px;left: -2px;"/>
                  </div>
                  <Avatar style="vertical-align: top;margin-top: 4px;">{{userList.find((secItem)=>{return secItem.id==item}).name[0]}}</Avatar>
                  <p class="name">{{userList.find((secItem)=>{return secItem.id==item}).name}}</p>
                </div>
                <div style="padding:5px"></div>
              </div>
            </div>
          </div>
        </div>
        <!--项目成员设置-->
        <div id="catalog6">
          <div style="border-top:1px dashed #d7dde4;">
            <div class="catalog">
              <div></div>
              <p>项目成员设置</p>
            </div>
            <div class="catalog" style="float: right;">
              <userSelector
                  :userList="selectUserList"
                  @inputChange="getSelectUserList($event)"
                  @selected="content.otherUser.push($event.id)"
              >
                <template slot="title">
                  <Icon type="md-add" color="#00a2e9" size="22" style="vertical-align: top;"/>
                  <p>添加项目成员</p>
                </template>
              </userSelector>
            </div>
          </div>
          <!--其他成员-->
          <div style="margin: 25px 0">
            <div style="display: inline-block;margin-right: 15px;">
              <div class="mousedischarge" style="margin-right:5px;" v-for="(item,index) in content.otherUser">
                <div class="close" @click="content.otherUser.splice(index,1)">
                  <Icon type="ios-close" color="white" size="20" style="position: absolute;top: -2px;left: -2px;"/>
                </div>
                <Avatar style="vertical-align: top;margin-top: 4px;">{{userList.find((secItem)=>{return secItem.id==item}).name[0]}}</Avatar>
                <p class="name">{{userList.find((secItem)=>{return secItem.id==item}).name}}</p>
              </div>
              <div style="padding:5px"></div>
            </div>
          </div>
        </div>
        <!--项目操作-->
        <div id="catalog7">
          <div style="border-top:1px dashed #d7dde4;">
            <div class="catalog">
              <div></div>
              <p>项目操作</p>
            </div>
          </div>
          <Row>
            <Col span="21" class="operation">
              <!--<p class="">若项目遇到撤案、搁置等不需要继续跟进的情况，可中止项目。中止的项目信息、文件等均为保留、可重新激活</p>-->
              <p>保存当前案件所变更的设置于与操作</p>
            </Col>
            <Col span="3">
              <Button @click="saveOtherSetting()" style="background-color: #eec712;" class="project-Button">保存设置</Button>
            </Col>
          </Row>
          <Row>
            <Col span="21" class="operation">
              <p class="">若项目已完全结案且符合归档标准，您可以归档它，归档后无法重新激活</p>
            </Col>
            <Col span="3">
              <Button style="background-color: #00a2e9;" class="project-Button" @click="fileProject()">归档项目</Button>
            </Col>
          </Row>
          <Row>
            <Col span="21" class="operation">
              <p class="">删除项目后、所有内容都会被删除，且无法恢复</p>
            </Col>
            <Col span="3">
              <Button @click="deleteProject()" style="background-color: #f75454;" class="project-Button">删除项目</Button>
            </Col>
          </Row>
        </div>
      </Col>
    </Row>

  </div>
</template>

<script>
  import userSelector from "../../../components/system/userSelector";
  export default {
    name: "setting",
//设置
    data() {
      return {
        informationData: '',
        cityList: [{value: 'New York', label: 'New York'},],
        content:{
          name:'',
          casetAmount:'',
          projectAmount:'',
          caseStage:'',
          caseDetails:'',
          causeTypeSelected:'',
          modelTypeSelected:'',
          modelSelected:'',
          createDate:'',
          procedures:'',
          company:'',
          contractor:{
            name:'',
            phone:'',
          },
          payType:'',
          receivingUnit:'',
          contactClient:'',
          source:[],
          manager:[],
          otherUser:[],
        },
        client:[],
        opposed:[],
        customerPanel:[0,1,2],
        userList:[],
        selectUserList:[],
        sourceSelectedList:[],
        managerSelectedList:[],
        otherUserSelectedList:[],
        causeTypeList:[],
        modelTypeList:[],
        modelList:[],
      }
    },
    components:{
      userSelector:userSelector,
    },
    mounted:function(){
      this.getUserList()
      this.getLitigationStatus()
      this.projectRegister()
    },
    methods: {
      //归档项目
      fileProject:function(){
        var _this = this
        _this.send({
          headers:'RC/CaseRecord',
          confirm:true,
          data:{
            CaseId:_this.$route.query.caseId,
          },
          success:function (res) {
            _this.$Notice.success({
              title:'系统消息',
              desc:'案件已归档！',
            })
            _this.$router.push({name:'projectList'})
          }
        })
      },
      //获取案件数据
      projectRegister: function () {
        var _this = this
        _this.send({
          headers: "E/ShowSingleCase",
          data: {
            CaseId: _this.$route.query.caseId
          },
          success: function (res) {
            console.log(res.case_action_id)
            _this.content.name=res.case_title
            _this.content.caseNumber=res.case_num
            _this.content.caseAmount=res.case_subject_matter
            _this.content.projectAmount=res.case_pay_count
            _this.content.caseStage=res.case_stage
            _this.content.caseDetails=res.case_situation
            _this.content.createDate=res.case_create_time
            _this.content.caseTypeId=res.case_type_id
            _this.content.payType=parseInt(res.case_charge_id)
            _this.content.receivingUnit=parseInt(res.case_acceptance_id)
            _this.content.causeTypeSelected=res.case_action_id//案由ID
            _this.content.modelTypeSelected=res.case_action_second_id//细分模板ID
            _this.content.modelSelected=res.case_action_detail_id//模板ID
            _this.content.source=res.case_from_id?res.case_from_id.split(','):[]
            _this.content.manager=res.case_executor_id?res.case_executor_id.split(','):[]
            _this.content.otherUser=res.case_member_id?res.case_member_id.split(','):[]
            _this.getCauseTypeList(true)
            _this.getModelTypeList(true)
            _this.getModelList(true)
          }
        })
      },
      //获取业务类型列表
      getCauseTypeList:function (unset) {
        var _this = this
        _this.causeTypeList = []
        if(unset==false){
          _this.content.causeTypeSelected=''
          _this.content.modelTypeSelected=''
          _this.content.modelSelected=''
        }
        _this.send({
          headers: "A/ShowActionByType",
          data:{
            CaseTypeId:_this.content.caseTypeId,
          },
          warningTips:false,
          success:function (res) {
            for(var index in res){
              _this.causeTypeList.push({id:res[index].CaseActionId,name:res[index].CaseActionTitle})
            }
          }
        })
      },
      //获取细分模板列表
      getModelTypeList:function(unset){
        var _this = this
        _this.modelTypeList = []
        if(unset==false) {
          _this.content.modelTypeSelected = ''
          _this.content.modelSelected = ''
        }
        _this.send({
          headers: "A/ShowDetailByAction ",
          data:{
            CaseActionId:_this.content.causeTypeSelected,
          },
          warningTips:false,
          success:function (res) {
            for(var index in res){
              _this.modelTypeList.push({id:res[index].CaseActionId,name:res[index].CaseActionTitle})
            }
          }
        })
      },
      //获取模板列表
      getModelList:function(unset){
        var _this = this
        _this.modelList = []
        if(unset==false){
          _this.content.modelSelected=''
        }
        _this.send({
          headers: "A/ShowModeByDetailList",
          data:{
            CaseActionId:_this.content.modelTypeSelected,
          },
          warningTips:false,
          success:function (res) {
            for(var index in res){
              _this.modelList.push({id:res[index].CaseActionDetailId,name:res[index].CaseActionDetailTitle})
            }
          }
        })
      },
      //获取当事人选项信息
      getLitigationStatus:function () {
        var _this = this
        _this.send({
          headers:'C/ShowIdentity',
          success:function (res) {
            _this.identity = []
            for(var index in res.LitigantTypeTitle){
              _this.identity.push({type:res.LitigantTypeTitle[index].LitigantTypeNature,value:res.LitigantTypeTitle[index].LitigantTypeId,label:res.LitigantTypeTitle[index].LitigantTypeTitle})
            }
            _this.litigation = []
            for(var index in res.LitigationLawsuit){
              _this.litigation.push({value:res.LitigationLawsuit[index].LitigationLawsuitId,label:res.LitigationLawsuit[index].LitigationLawsuitName})
            }
            _this.getLitigationList()
          }
        })
      },
      //获取当事人列表
      getLitigationList:function(){
        var _this = this
        _this.send({
          headers:'E/LitigatsList',
          data:{
            CaseId:_this.$route.query.caseId,
          },
          success:function (res) {
            for(var index in res){
              if(res[index].LitigationStatusId==1){
                _this.client.push({
                  id:res[index].LitigantId,
                  name:res[index].LitigantName,
                  litigation:res[index].LawsuitId,
                  identity :res[index].LitigantTypeId,
                  IDCardCode:res[index].LitigantIdCard,
                })
              }
              if(res[index].LitigationStatusId==2){
                _this.opposed.push({
                  id:res[index].LitigantId,
                  name:res[index].LitigantName,
                  litigation:res[index].LawsuitId,
                  identity :res[index].LitigantTypeId,
                  IDCardCode:res[index].LitigantIdCard,
                })
              }
            }
          }
        })
      },
      //保存其他信息
      saveOtherSetting:function(model){
        var _this = this
        if(model==true){
          _this.$Modal.confirm({
            title:'警告',
            content:'修改模板会导致清空任务，是否继续操作？',
            onOk:function () {
              saveSetting()
            },
          })
        }else{
          saveSetting()
        }
        function saveSetting() {
          var tempArr = []
          for(var i=0;i<_this.client.length;i++){
            tempArr.push(_this.client[i].id)
          }
          for(var i=0;i<_this.opposed.length;i++) {
            tempArr.push(_this.opposed[i].id)
          }
          _this.send({
            headers:'E/updateSet ',
            data:{
              CaseId:_this.$route.query.caseId,
              CaseActionId:_this.content.causeTypeSelected,//案由ID
              CaseActionSecondId:_this.content.modelTypeSelected,//细分模板ID
              CaseActionDetailId:_this.content.modelSelected,//模板ID
              LitigantsId:tempArr.toString(),
              CaseFromId:_this.content.source.toString(),//案源律师
              CaseExecutorId:_this.content.manager.toString(),//承办律师
              CaseMemberId:_this.content.otherUser.toString(),//其他律师
            },
            success:function (res) {
              _this.$Notice.success({
                title:'系统提示',
                desc:'保存成功！'
              })
            }
          })
        }
      },
      //删除项目
      deleteProject:function(){
        var _this = this
        _this.send({
          headers:'E/DelCase',
          confirm:true,
          data:{
            CaseId:_this.$route.query.caseId,
          },
          success:function () {
            _this.$router.push({name:'projectList'})
          }
        })
      },
      //保存当事人信息
      saveLitigation:function(){
        var _this = this
        var tempArr=[]
        for(var i=0;i<_this.client.length;i++){
          tempArr.push({
            LitigationStatusId:1,
            LitigantName:_this.client[i].name,
            LitigantLawsuit :_this.client[i].litigation,//诉讼地位ID
            LitigantTypeId :_this.client[i].identity,
            LitigantId:_this.client[i].id,
            // LitigantMobile:this.client[i].mobile,
            LitigantIdCard:_this.client[i].IDCardCode,
          })
        }
        for(var i=0;i<_this.opposed.length;i++){
          tempArr.push({
            LitigationStatusId:2,
            LitigantName:_this.opposed[i].name,
            LitigantLawsuit :_this.opposed[i].litigation,
            LitigantId:_this.opposed[i].id,
            LitigantTypeId :_this.opposed[i].identity,
            // LitigantMobile:this.opposed[i].mobile,
            LitigantIdCard:_this.opposed[i].IDCardCode,
          })
        }
        _this.send({
          headers:'E/LitigatsUpdate',
          data:{
            CaseId:_this.$route.query.caseId,
            LitigationArr:tempArr,
          },
          success:function (res) {
            _this.$Notice.success({
              title:'系统消息',
              desc:'保存成功！'
            })
          }
        })
      },
      //获取当事人列表
      // getLitigation:function(){
      //   var _this = this
      //   _this.send({
      //     headers:'E/ShowSet',
      //     data:{
      //       CaseId:_this.$route.query.caseId
      //     },
      //     success:function (res) {
      //       console.log(res)
      //     }
      //   })
      // },
      sourceMove:function(keys){
        this.sourceSelectedList = []
        this.content.source = keys
        for(var i=0;i<keys.length;i++){
          for(var j=0;j<this.userList.length;j++){
            if(keys[i]==this.userList[j].key){
              this.sourceSelectedList.push({id:this.userList[j].key,name:this.userList[j].label,icon:this.userList[j].icon})
            }
          }
        }
      },
      managerMove:function(keys){
        this.managerSelectedList = []
        this.content.manager = keys
        for(var i=0;i<keys.length;i++){
          for(var j=0;j<this.userList.length;j++){
            if(keys[i]==this.userList[j].key){
              this.managerSelectedList.push({id:this.userList[j].key,name:this.userList[j].label,icon:this.userList[j].icon})
            }
          }
        }
      },

      otherUserMove:function(keys){
        this.otherUserSelectedList = []
        this.content.otherUser = keys
        for(var i=0;i<keys.length;i++){
          for(var j=0;j<this.userList.length;j++){
            if(keys[i]==this.userList[j].key){
              this.otherUserSelectedList.push({id:this.userList[j].key,name:this.userList[j].label,icon:this.userList[j].icon})
            }
          }
        }
      },
      //获取用户数据
      getUserList:function(searchText){
        var _this = this
        _this.userList = []
        _this.send({
          headers:'C/LawList',
          data:{
            key:searchText||'',
          },
          success:function (res) {
            var tempObj = []
            for(var index in res){
              tempObj.push({id:res[index].UserId,name:res[index].UserName,icon:res[index].UserImg})
            }
            _this.userList = tempObj
            _this.selectUserList = tempObj
          }
        })
      },
      lawList:function(){
        var _this = this
        _this.getUserList()
      },
      //获取用户搜索数据
      getSelectUserList:function(searchText){
        var _this = this
        _this.selectUserList = []
        _this.send({
          headers:'C/LawList',
          data:{
            key:searchText||'',
          },
          success:function (res) {
            var tempObj = []
            for(var index in res){
              tempObj.push({id:res[index].UserId,name:res[index].UserName,icon:res[index].UserImg})
            }
            _this.selectUserList = tempObj
          }
        })
      },
    },
  }
</script>

